// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"4c4c96a1","818":"8b3b425d"}[chunkId] + ".chunk.css";
};